import { DoOnboarding } from "~/api/apiRouteTypes/DoOnboardingRoute";
import { fetchPost } from "~/utils/fetch";

export type PostDoOnboardingResult =
  DoOnboarding.PostDoOnboardingControllerHandle.ResponseBody;

/**@description 온보딩 진행 이력 기록 */
export const postDoOnboarding = () =>
  fetchPost<PostDoOnboardingResult>({
    url: `/do-onboarding`,
  });
